$(window).on("pageshow", function () {
	$("video").each(function () {
		this.play();
	});
});

$(function () {
	//ホバー対策
	if('ontouchend' in document) {
	}
	else {
		$("html").addClass("notouchable");
	}

	//自動再生補助


	//SPメニュー
	let TimerNavi	=	0;

	$(".navi-menus-inner").on("scroll", function () {
		let $target	=	$(this);

		clearTimeout(TimerNavi);

		TimerNavi	=	setTimeout(function () {
			$target.parent().addClass("ex-left").addClass("ex-right");
			
			if($target.scrollLeft() <= 0) {
				$target.parent().removeClass("ex-right");
			}
			else if($target.scrollLeft() + 2 >= $target.get(0).scrollWidth - $target.get(0).offsetWidth) {
				$target.parent().removeClass("ex-left");
			}
		}, 30);
	}).trigger("scroll");

	$(".navi-menus > span").on("click", function () {
		let $target	=	$(this);
		let adjust	=	$target.width();

		if($(".navi-menus").attr("data-lock")) {
			return;
		}
		
		$(".navi-menus").attr("data-lock", 1);

		if($target.hasClass("ex-prev")) {
			$(".navi-menu").each(function () {
				let $target	=	$(this);
				
				if($target.position().left > adjust + 20) {
					$(".navi-menus-inner").stop().animate({
						scrollLeft	:	$(".navi-menus-inner").scrollLeft() + $target.position().left - adjust,
					},
					{
						complete	:	function () {
							$(".navi-menus").removeAttr("data-lock");
						}
					});

					return false;
				}
			});
		}
		else if($target.hasClass("ex-next")) {
			$($(".navi-menu").get().reverse()).each(function () {
				let $target	=	$(this);
				
				if($target.position().left < adjust) {
					$(".navi-menus-inner").stop().animate({
						scrollLeft	:	$(".navi-menus-inner").scrollLeft() + $target.position().left - adjust,
					},
					{
						complete	:	function () {
							$(".navi-menus").removeAttr("data-lock");
						}
					});

					return false;
				}
			});
		}
	});

	$(".header-menu").on("click", function () {
		let $target	=	$(this);

		$target.toggleClass("ex-opened");

		if($target.hasClass("ex-opened")) {
			$(".header").addClass("ex-opened");
		}
		else {
			$(".header").removeClass("ex-opened");
		}
	});

	//ヘッダーメニュー
	$(window).on("scroll", function () {
		let $target	=	$(this);
		let $navi	=	$(".navi");
		
		if($navi.length != 0) {
			if($target.scrollTop() >= $navi.offset().top) {
				$(".header").addClass("ex-floating");
			}
			else {
				$(".header").removeClass("ex-floating");
			}
		}
		else {
			$(".header").addClass("ex-floating");
			$(".main").addClass("ex-floating");
		}
	}).trigger("scroll");

	//モーダル
	$(".ex-modal-open").on("click", function () {
		let $target		=	$(this);
		let $wrapper	=	$(".modal .modal-item[data-name=" + $target.attr("data-target") +"]");

		$(".modal .modal-item").hide();
		$wrapper.show();

		$(".modal").fadeIn();

		$("body").css({
			overflow: "hidden",
		});

		$wrapper.find("iframe").get(0).contentWindow.postMessage('{"event":"command", "func":"playVideo"}', '*');
	});

	$(".modal .ex-close").on("click", function () {
		let $wrapper	=	$(this).closest(".modal .modal-item");

		$wrapper.find("iframe").get(0).contentWindow.postMessage('{"event":"command", "func":"pauseVideo"}', '*');

		$(".modal").fadeOut(function () {
			$("body").css({
				overflow: "",
			});
		});
	});

	$(".modal, .header").on("touchmove", function (e) {
		e.preventDefault();
		e.stopPropagation();
	});

	//スワイパー
	new Swiper('.result-case-slider', {
		slidesPerView	:	"auto",
		pagination	:	{
			el			:	'.swiper-pagination',
			type		:	'bullets',
			clickable	:	true,
		},
		navigation	:	{
			nextEl	:	'.ex-next',
			prevEl	:	'.ex-prev',
		},
		scrollbar	:	{
			el			:	'.ex-scrollbar',
			hide		:	false,
			draggable	:	true,
		},
	});

	//動画レスポンシブ
	let $media	=	$(matchMedia('(max-width: 960px)'));

	$media.on("change", function (e) {
		let $video	=	$(".business-video video");
		
		if(e.currentTarget.matches) {
			$video.attr("src", $video.attr("data-sp"));
		}
		else {
			$video.attr("src", $video.attr("data-pc"));
		}
	}).trigger("change");

	$(".result-chart").on("inview", function () {
		$(this).addClass("ex-inview");
	});

	//ニュース取り込み
	if($(".result-news-items").length != 0) {
		$.ajax({
			url			:	"https://kges.co.jp/wpcpl/relation.php",
			type		:	"get",
			dataType 	:	"json",
		}).done(function (results) {
			$(".result-news-items").empty();

			$.each(results, function (key, result) {
				$(".result-news-items").append(
					'<li>'+
					'	<a class="result-news-item" href="'+ result.link +'" target="_blank">'+
					'		<div class="result-news-item-date">'+ result.date +'</div>'+
					'		<div class="result-news-item-inner">'+
					'			<div class="result-news-item-headline">'+ result.title +'</div>'+
					'			<div class="result-news-item-arrow">'+
					'				<span class="ex-arrow"></span>'+
					'			</div>'+
					'		</div>'+
					'	</a>'+
					'</li>'
				);
			});
		});
	}
});